import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { Icon } from '../Icon/Icon';

interface Props {
  label?: string;
  mode?: 'dashed' | 'solid';
}

export const LoadingSpinner = memo(({ label, mode = 'solid' }: Props) => {
  const intl = useIntl();
  return (
    <Icon
      icon={mode === 'dashed' ? 'loading-dashed' : 'loading'}
      label={
        label ??
        intl.formatMessage({
          id: 'LoadingSpinner.loadingLabel',
          defaultMessage: 'Loading',
          description: 'Default label for loading spinner',
        })
      }
      role="status"
    />
  );
});
